import React, { useState } from 'react';

import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Paper from '@material-ui/core/Paper';

import * as classes from '../../../components/BobActionMenu.module.css';

const ContactsTableActionMenu = ({
    handleCreateContact,
    handleDeleteContacts,
    handleContactExport,
    ...props
}) => {

    const [menuOpen, setMenuOpen] = useState(false);
    const handleToggle = () => {
        setMenuOpen(!menuOpen);
    };

    const handleClickAway = () => {
        setMenuOpen(false);
    };

    const renderMenu = () => {
        return <Paper className={classes.BobActionMenu}>
            <Button
                // eslint-disable-next-line no-console
                onClick={() => handleCreateContact()}
            >
                <span className="material-icons-outlined md-18">
                    add
                </span>
                <span className={classes.MenuItemText}>Add New Contact</span>
            </Button>
            {/*<Button*/}
            {/*    // eslint-disable-next-line no-console*/}
            {/*    onClick={() => console.log('Clicked')}*/}
            {/*>*/}
            {/*    <span className="material-icons-outlined md-18">*/}
            {/*        check_circle*/}
            {/*    </span>*/}
            {/*    <span className={classes.MenuItemText}>Activate</span>*/}
            {/*</Button>*/}
            {/*<Button*/}
            {/*    // eslint-disable-next-line no-console*/}
            {/*    onClick={() => console.log('Clicked')}*/}
            {/*>*/}
            {/*    <span className="material-icons-outlined md-18">*/}
            {/*        do_not_disturb_on*/}
            {/*    </span>*/}
            {/*    <span className={classes.MenuItemText}>Deactivate</span>*/}
            {/*</Button>*/}
            <Button
                // eslint-disable-next-line no-console
                onClick={() => handleContactExport()}
            >
                <span className="material-icons-outlined md-18">
                    file_download
                </span>
                <span className={classes.MenuItemText}>Export</span>
            </Button>
            <Button
                // eslint-disable-next-line no-console
                onClick={() => handleDeleteContacts()}
            >
                <span className="material-icons-outlined md-18">
                    delete
                </span>
                <span className={classes.MenuItemText}>Delete</span>
            </Button>
        </Paper>;
    };


    return (
        <ClickAwayListener
            onClickAway={() => handleClickAway()}
        >
            <div>
                <React.Fragment>
                    <Button
                        onClick={handleToggle}
                        className={menuOpen ? classes.BobActionButtonActive : classes.BobActionButton}
                    >
                        Actions
                        <i className={`fas fa-chevron-${menuOpen ? 'up' : 'down'}`} aria-hidden="true" />
                    </Button>
                    {menuOpen ? renderMenu() : null}
                </React.Fragment>
            </div>
        </ClickAwayListener>
    );
};

export default ContactsTableActionMenu;
